import { ProductProvider } from '@elem/compPage/RapidSeries/ProductProvider';
import { IPageStatus } from '@elem/compPage/RapidSeries/config/IPageStatus';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import { useLang } from '@/i18n';
import { redirectTo404 } from '@/utils';
import RapidSeries from '@elem/compPage/RapidSeries';
import { useRouter } from 'next/router';
import { GetServerSidePropsContext } from 'next/types';

const whiteLocaleList = ['us', 'ca', 'jp', 'eu', 'uk', 'de', 'fr', 'it', 'es'];
export default function Page({ SEO, lang, timeLine, pageStatus, systemTime }: any) {
    const { locale = 'us' } = useRouter();
    const { t } = useLang('rapidseries');

    const initState = {
        systemTime: systemTime,
        pageStatus: pageStatus,
        timeLine: timeLine,
        productTabActive: 'Product',
    };

    return (
        <PageLayout isNoFixed={true}>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={locale} list={whiteLocaleList} pathname="rapid-series-power-bank" />
            <ProductProvider state={initState}>
                <RapidSeries />
            </ProductProvider>
        </PageLayout>
    );
}
const isPrd = process.env.NEXT_PUBLIC_MODY === 'prd'; //是否是生产环境
export async function getServerSideProps({ locale = 'us', query }: GetServerSidePropsContext) {
    // 非白名单404
    if (!whiteLocaleList.includes(locale)) {
        return redirectTo404();
    }
    const { debug, _timer } = query;

    let data = null;
    try {
        data = require(`elem/compPage/RapidSeries/config/times/${locale}.js`);
    } catch (err) {
        data = require(`elem/compPage/RapidSeries/config/times/us.js`);
    }

    const timeLine = data.timeLine || null; // 代码保存的时间线

    // 时间节点判断 正式环境未开始重定向404

    let systemTime = new Date().getTime(); // 系统时间
    if (_timer) {
        // 读取url上的时间进行测试
        const _timer2 = `${_timer} GMT+8`;
        systemTime = new Date(_timer2).getTime();
    }

    // 当前阶段
    let pageStatus = IPageStatus.statusA;
    if (debug) {
        // 是否进入调试状态
        pageStatus = debug as any;
    } else if (timeLine) {
        if (systemTime >= timeLine?.statusD?.start) {
            // 系统时间进入 statusD 时间段
            pageStatus = IPageStatus.statusD;
        } else if (systemTime >= timeLine?.statusC?.start) {
            // 系统时间进入 statusC 时间段
            pageStatus = IPageStatus.statusC;
        } else if (systemTime >= timeLine?.statusB?.start) {
            // 系统时间进入 statusB 时间段
            pageStatus = IPageStatus.statusB;
        } else if (systemTime >= timeLine?.statusA?.start) {
            // 系统时间进入 statusA 时间段
            pageStatus = IPageStatus.statusA;
        } else if (isPrd) {
            // 系统时间不在上述时间段,且进入生产环境才跳转404
            return redirectTo404();
        }
    }
    return {
        props: {
            systemTime,
            timeLine: timeLine,
            debug: debug || '',
            pageStatus: pageStatus,
        },
    };
}
